import { gql } from 'graphql-request'

export interface SwapHistoryEntry {
  id: string
  timestamp: string
  transaction: { id: string }
  pair: {
    token0: { symbol: string }
    token1: { symbol: string }
  }
  amount0In: string
  amount1In: string
  amount0Out: string
  amount1Out: string
  amountUSD: string
}

interface SwapHistoryResponse {
  swaps: SwapHistoryEntry[]
}

interface GraphQLRequester {
  request<T>(document: string, variables?: Record<string, unknown>): Promise<T>
}

const WALLET_SWAP_HISTORY = gql`
  query walletSwapHistory($account: Bytes!, $first: Int!, $skip: Int!) {
    swaps(first: $first, skip: $skip, orderBy: timestamp, orderDirection: desc, where: { from: $account }) {
      id
      timestamp
      transaction {
        id
      }
      pair {
        token0 {
          symbol
        }
        token1 {
          symbol
        }
      }
      amount0In
      amount1In
      amount0Out
      amount1Out
      amountUSD
    }
  }
`

export const fetchWalletSwapHistory = async (
  client: GraphQLRequester,
  account: string,
  first: number,
  skip = 0,
): Promise<SwapHistoryEntry[]> => {
  const { swaps } = await client.request<SwapHistoryResponse>(WALLET_SWAP_HISTORY, {
    account: account.toLowerCase(),
    first,
    skip,
  })
  return swaps
}
